const mediaQuery = window.matchMedia("(max-width: 520px)");

if (document.querySelector(".v_benefits")) {
  let observerOptions = {
    rootMargin: "-250px",
  };

  if (mediaQuery.matches) {
    observerOptions.rootMargin = "-140px";
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const elements = document.querySelectorAll(
          ".v_proposal_animated_icons"
        );
        Array.from(elements).forEach((element) => {
          element.classList.add("v_proposal_icon_show");
          setInterval(() => {
            element.classList.add("v_proposal__infinite_animation");
          }, 3000);
        });
      }
    });
  }, observerOptions);

  const proposalContainer = document.querySelector(".v_proposal__container");
  observer.observe(proposalContainer);
}
